import { render, staticRenderFns } from "./Accord.vue?vue&type=template&id=906c8684&"
import script from "./Accord.vue?vue&type=script&lang=js&"
export * from "./Accord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports